// extracted by mini-css-extract-plugin
export default {"ingrediensblock":"A-","heading":"B-","item":"C-","fadeIn":"E-","imagewrapper":"F-","modalheader":"G-","amount":"H-","name":"I-","desc":"J-","moredetails":"K-","ingheader":"L-"};
    if(module.hot) {
      // 1713969938189
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  